import ReactDOM from "react-dom";
import { TweetDropUI } from "./TweetDropUI";

ReactDOM.render(<TweetDropUI />, document.getElementById("main"));

